module.exports = __webpack_public_path__ + "img/icone_ceresia.d2b34e02.png";